import type { LucideIcon } from "lucide-react"
import {
  Activity,
  ArrowLeft,
  BarChart3,
  Bell,
  BookOpen,
  Bot,
  Brain,
  Briefcase,
  BriefcaseBusiness,
  Building2,
  CalendarCheck,
  CircleArrowUp,
  ClipboardList,
  CreditCard,
  Eye,
  FlaskConical,
  Globe2,
  Home,
  FileText,
  Headset,
  Heart,
  HeartPulse,
  LayoutGrid,
  Leaf,
  Lightbulb,
  Link2,
  Megaphone,
  MessageSquare,
  Pill,
  Plane,
  Plug,
  Radio,
  Search,
  Settings,
  Shield,
  SlidersHorizontal,
  Soup,
  Sparkles,
  Stethoscope,
  Thermometer,
  User,
  UserPlus,
  Users,
} from "lucide-react"

/** Lucide in source; Yes Human Vite alias may resolve to @sketchyicons/react at runtime. */
export type SidebarIcon = LucideIcon

export const SIDEBAR_ICON_REGISTRY = {
  Activity,
  ArrowLeft,
  BarChart3,
  Bell,
  BookOpen,
  Bot,
  Brain,
  Briefcase,
  BriefcaseBusiness,
  Building2,
  CalendarCheck,
  CircleArrowUp,
  ClipboardList,
  CreditCard,
  Eye,
  FlaskConical,
  Globe2,
  Home,
  FileText,
  Headset,
  Heart,
  HeartPulse,
  LayoutGrid,
  Leaf,
  Lightbulb,
  Link2,
  Megaphone,
  MessageSquare,
  Pill,
  Plane,
  Plug,
  Radio,
  Search,
  Settings,
  Shield,
  SlidersHorizontal,
  Soup,
  Sparkles,
  Stethoscope,
  Thermometer,
  User,
  UserPlus,
  Users,
} satisfies Record<string, LucideIcon>

export type SidebarIconKey = keyof typeof SIDEBAR_ICON_REGISTRY

export function getSidebarIcon(iconName?: string): SidebarIcon {
  if (iconName && iconName in SIDEBAR_ICON_REGISTRY) {
    return SIDEBAR_ICON_REGISTRY[iconName as SidebarIconKey]
  }

  return Bot
}
